import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleListDto } from '../../vehicles/dtos/vehicle-list.dto';
import { VehicleRoadTaxRecordCategoryEnum } from '../enums/vehicle-road-tax-record-category.enum';
import { VehicleRoadTaxStatusEnum } from '../enums/vehicle-road-tax-status.enum';

import { VehicleRoadTaxLinksDto } from './vehicle-road-tax-links.dto';

/**
 * Vehicle road tax DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE_ROAD_TAX)
export class VehicleRoadTaxListDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleRoadTaxStatusEnum;
  recordCategory!: VehicleRoadTaxRecordCategoryEnum;
  vehicle!: VehicleListDto;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  tags?: TagListDto[] | null;
  links?: VehicleRoadTaxLinksDto | null;
}
